export const redirect = (url: string) => window.location.assign(url);
